import customTwMerge from 'utils/twMerge';
import { CCard } from 'components/atoms';
import { InfoCardProps } from 'types/molecules';

export default function InfoCard({ description, className, type }: InfoCardProps) {
  const preset = {
    info: {
      src: new URL('assets/svg/info-circle.svg', import.meta.url).href,
      cardClassName: 'bg-primary-300/30',
      descriptionClassName: 'text-primary-500',
    },
    phone: {
      src: new URL('assets/svg/phone.svg', import.meta.url).href,
      cardClassName: 'bg-neutral-background4 px-6',
      descriptionClassName: 'text-neutral-500',
    },
    email: {
      src: new URL('assets/svg/email.svg', import.meta.url).href,
      cardClassName: 'bg-neutral-background4 px-6',
      descriptionClassName: 'text-neutral-500',
    },
  };

  const presetType = type && preset[type];

  return (
    <CCard
      className={customTwMerge(
        'flex items-center gap-3 overflow-auto p-3',
        presetType.cardClassName,
        className
      )}
    >
      <img src={presetType.src} alt={`${type} icon`} />

      <p data-sentry-mask={type === 'phone' || type === 'email'} className={presetType.descriptionClassName}>{description}</p>
    </CCard>
  );
}
